import { Link } from "react-router-dom";
import { Menu, Compass, CalendarDays, Rss, UserCircle, Store, BarChart3, Settings, Tag, LogOut, Bell, MessageSquare } from "lucide-react";
import { CountBadge } from "@/components/CountBadge";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Avatar } from "@/components/Avatar";

export function MobileMenu({ user, unread, onLogout }) {
  const items = [
    ["explore", "/explore", Compass, "Explore"],
    ["trip", "/trip", CalendarDays, "My Trip"],
    ["following", "/following", Rss, "Following"],
    ["profile", "/traveler/me", UserCircle, "My Profile"],
    ["notifications", "/notifications", Bell, "Notifications", unread.personal],
    ...(user.role === "vendor" || user.role === "admin" ? [["business", "/vendor", Store, "My Business"], ["reviews", "/vendor/reviews", MessageSquare, "Reviews", unread.business]] : []),
    ...(user.role === "admin" ? [["owner", "/admin", BarChart3, "Owner Dashboard"]] : []),
    ["account", "/account", Settings, "Account"],
    ["pricing", "/pricing", Tag, "Pricing"],
  ];
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button data-testid="nav-mobile-menu" className="md:hidden flex items-center gap-2 rounded-full border border-[#26334D] pl-1 pr-3 py-1" aria-label="Menu">
          <Avatar url={user.avatar_url} name={user.name} size="h-8 w-8" testid="nav-mobile-avatar" />
          <Menu className="h-4 w-4" />
          <CountBadge n={unread.personal + unread.business} testid="nav-mobile-badge" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56 bg-[#151C2C] border-[#26334D] text-white">
        <div className="px-2 py-2 text-sm"><p className="font-semibold">{user.name}</p><p className="text-xs text-slate-400 truncate">{user.email}</p></div>
        <DropdownMenuSeparator className="bg-[#26334D]" />
        {items.map(([id, to, Icon, label, n]) => (
          <DropdownMenuItem key={id} asChild>
            <Link to={to} data-testid={`nav-mobile-${id}`} className="cursor-pointer flex items-center gap-2 py-2.5"><Icon className="h-4 w-4 text-[#FF3B6B]" /> {label}<span className="ml-auto"><CountBadge n={n} testid={`nav-mobile-${id}-badge`} /></span></Link>
          </DropdownMenuItem>
        ))}
        <DropdownMenuSeparator className="bg-[#26334D]" />
        <DropdownMenuItem data-testid="nav-mobile-logout" onClick={onLogout} className="cursor-pointer flex items-center gap-2 py-2.5"><LogOut className="h-4 w-4" /> Log out</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
